import React, { createContext, useContext } from 'react';
import { MODAL_SECTIONS, resolveModalSection } from './modalTheme';

const ModalSectionContext = createContext(MODAL_SECTIONS.DEFAULT);

export function ModalSectionProvider({ section, children }) {
  const key = resolveModalSection(section);
  return <ModalSectionContext.Provider value={key}>{children}</ModalSectionContext.Provider>;
}

export function useModalSection() {
  return useContext(ModalSectionContext);
}
